import layout from '../utils/layout';
import Parallax from '../components/Parallax';

export default class DynamicImageBlock {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;
    this.parallax = this.settings.parallax;
    this.fixedHeightMobile = this.settings.fixedHeightMobile;
    this.fixedHeightDesktop = this.settings.fixedHeightDesktop;

    this.parallaxObject = null;

    if (this.parallax) {
      this.parallaxObject = new Parallax({
        img: this.el.querySelector('img, svg'),
        container: this.el.querySelector('.picture-block-image'),
        isVisible: () => true,
      });

      const isNotFixed = (layout.isBreakpoint('S','M') && !this.fixedHeightMobile)
      || (!layout.isBreakpoint('S','M') && !this.fixedHeightDesktop);

      if (isNotFixed) {
        this.el.querySelector('.picture-block-image').style.height = this.el.querySelector('img, svg').clientHeight + 'px';
      }

      window.addEventListener('resize', () => {
        if (isNotFixed) {
          this.el.querySelector('.picture-block-image').style.height = this.el.querySelector('img, svg').clientHeight + 'px';
        } else {
          this.el.querySelector('.picture-block-image').style.height = '';
        }
      });
    }
  }

  onSectionUnload() {
    if (this.parallax) {
      this.parallaxObject.unload();
      this.parallaxObject = null;
    }
  }
}
